import { render, staticRenderFns } from "./typeTestProcessSearch.vue?vue&type=template&id=09f89e36&scoped=true"
import script from "./typeTestProcessSearch.vue?vue&type=script&lang=js"
export * from "./typeTestProcessSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f89e36",
  null
  
)

export default component.exports